import { Outlet } from "react-router-dom";
import { useRef, useState, useEffect } from "react";
import EnhancedResponsiveAppBar from "../components/AppBar";

const Layout = ({ activeSection, setActiveSection }) => {
  const navbarRef = useRef(null);
  const [showAppBar, setShowAppBar] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY > lastScrollY) {
        // Scrolling down, hide AppBar
        setShowAppBar(false);
      } else {
        // Scrolling up, show AppBar
        setShowAppBar(true);
      }

      setLastScrollY(currentScrollY);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [lastScrollY]);

  return (
    <>
      <div
        ref={navbarRef}
        style={{
          transition: "top 0.3s",
          top: showAppBar ? "0" : "-80px",
          position: "fixed",
          width: "100%",
          zIndex: "1000",
        }}
      >
        <EnhancedResponsiveAppBar />
      </div>

      <div>
        <Outlet />
      </div>
    </>
  );
};

export default Layout;
